import { Component, ViewChild, Renderer2, AfterViewInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { DistributionUploadFileComponent } from '../shared/dialogs/distribution-upload-file/distribution-upload-file.component';
import { DistributionsService } from 'src/app/services/distributions.service';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { MainService } from 'src/app/services/main.service';
import { CampaignsService } from 'src/app/services/campaigns.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { DistributionUploadGuidesFileComponent } from '../shared/dialogs/distribution-upload-guides-file/distribution-upload-guides-file.component';
import { DistributionUploadRacksFileComponent } from '../shared/dialogs/distribution-upload-racks-file/distribution-upload-racks-file.component';
import { BoxMaterialsListComponent } from '../shared/dialogs/box-materials-list/box-materials-list.component';
import { BgMaterialsListComponent } from '../shared/dialogs/bg-materials-list/bg-materials-list.component';
import { RackMaterialsListComponent } from '../shared/dialogs/rack-materials-list/rack-materials-list.component';
import Swal from 'sweetalert2';
import { MatTabGroup } from '@angular/material/tabs';
import { MfAddComponent } from '../shared/dialogs/mf-add/mf-add.component';
import { MfDocComponent } from '../shared/dialogs/mf-doc/mf-doc.component';
import { CloseBoxesComponent } from '../shared/dialogs/close-boxes/close-boxes.component';
import { DistributionUploadShipmentsFileComponent } from '../shared/dialogs/distribution-upload-shipments-file/distribution-upload-shipments-file.component';
import { DistributionEditShipmentDataComponent } from '../shared/dialogs/distribution-edit-shipment-data/distribution-edit-shipment-data.component';
import { DistributionMaterialsUploadImgsComponent } from '../shared/dialogs/distribution-materials-upload-imgs/distribution-materials-upload-imgs.component';
import { DistributionMaterialsImgSlidersComponent } from '../shared/dialogs/distribution-materials-img-sliders/distribution-materials-img-sliders.component';
import { DistributionUploadOrderedGuidesComponent } from '../shared/dialogs/distribution-upload-ordered-guides/distribution-upload-ordered-guides.component';
import { ValidationQrComponent } from '../shared/dialogs/validation-qr/validation-qr.component';
import * as printJS from 'print-js';
import { HttpClient } from '@angular/common/http';
import { PeriodosComponent } from '../shared/dialogs/periodos/periodos.component';
import { DistributionEditTrackingComponent } from '../shared/dialogs/distribution-edit-tracking/distribution-edit-tracking.component';
import { MfPreviewComponent } from '../shared/dialogs/mf-preview/mf-preview.component';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { InventarioEditRecibidoComponent } from '../shared/dialogs/inventario-edit-recibido/inventario-edit-recibido.component';
import { InventarioHistorialComponent } from '../shared/dialogs/inventario-historial/inventario-historial.component';
import { ViewPickupEvidenceComponent } from '../shared/dialogs/view-pickup-evidence/view-pickup-evidence.component';
import { BulkConfig } from '../shared/dialogs/bulk-config/bulk-config.component';
import { ChangeDetectorRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Catalog, SDSelectorData, SDShowcaseEntry } from 'src/app/models/campaigns.model';
import { firstValueFrom } from 'rxjs';
import { DistributionUploadMaterialesComponent } from '../shared/dialogs/distribution-upload-materiales/distribution-upload-materiales.component';
import { MaterialsSettingsComponent } from '../shared/dialogs/materials-settings/materials-settings.component';
import { RackComparteInvComponent } from '../shared/dialogs/rack-comparte-inv/rack-comparte-inv.component';
import { MaterialComponentsListComponent } from '../shared/dialogs/material-components-list/material-components-list.component';


@Component({
  selector: 'app-distribution',
  templateUrl: './distribution.component.html',
  styleUrls: ['./distribution.component.scss']
})
export class DistributionComponent {
  @ViewChild('tabGroup', {static: false}) tab!: MatTabGroup;  
  campana!: any;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  dsSucursales!: MatTableDataSource<any>;
  colsSucursales: string[] = ['box_id', 'id_ext', 'filial', 'zona', 'sucursal', 'consecutivo', 'status', 'tracking_number', 'archivo', 'actions'];

  @ViewChild("paginatorBG") paginatorBG!: MatPaginator;
  @ViewChild("sortBG") sortBG!: MatSort;
  dsBGs!: MatTableDataSource<any>;
  colsBGs: string[] = ['bag_id', 'BG', 'cantidad', 'cantidad_sku', 'cantidad_pza','recibido','editar_recibido','pendiente','empacado','actual','en_linea','danado','available', 'validacion_qr', 'actions', 'historial'];

  @ViewChild("paginatorRK") paginatorRK!: MatPaginator;
  @ViewChild("sortRK") sortRK!: MatSort;
  dsRacks!: MatTableDataSource<any>;
  colsRacks: string[] = ['nombre', 'line', 'tipo', 'comparte' ,'actions'];

  @ViewChild("paginatorMat") paginatorMat!: MatPaginator;
  @ViewChild("sortMat") sortMat!: MatSort;
  dsMaterials!: MatTableDataSource<any>;
  colsMat: string[] = ['sku', 'nombre', 'tipo', 'cantidad', 'peso', 'recibido', 'pendiente', 'empacado', 'actual', 'en_linea', 'danado', 'status', 'imagen', 'actions'];

  @ViewChild("paginatorMf") paginatorMf!: MatPaginator;
  @ViewChild("sortMf") sortMf!: MatSort;
  dsMf!: MatTableDataSource<any>;
  colsMf: string[] = ['nombre', 'paqueteria', 'empresa', 'recolector', 'cantidad', 'fecha_salida', 'actions'];

  @ViewChild("paginatorSh") paginatorSh!: MatPaginator;
  @ViewChild("sortSh") sortSh!: MatSort;
  dsSh!: MatTableDataSource<any>;
  //colsSh: string[] = ['actions', 'status', 'id', 'consecutivo', 'address','reference', 'provider', 'carrier', 'service', 'weight', 'length', 'width', 'height'];
  colsShBase: string[] = ['actions', 'status', 'id', 'consecutivo', 'address','reference', 'provider', 'carrier', 'service', 'weight', 'length', 'width', 'height'];
  colsSh: string[] = [];
  originalDsShData: any[] = [];

  @ViewChild("paginatorFiles") paginatorFiles!: MatPaginator;
  @ViewChild("sortFiles") sortFiles!: MatSort;
  dsArchivos!: MatTableDataSource<any>;
  colArchivos: string[] = ['select', 'id', 'nombre', 'total_guias', 'fecha', 'generate', 'imprimir'];

  @ViewChild(MatPaginator) paginatorGeneral!: MatPaginator;
  dsGeneral!: MatTableDataSource<any>;
  colsGeneral: string[] = ['consecutivo','fecha', 'cajas', 'periodos', 'actions'];
  @ViewChild("paginatorTracking") paginatorTracking!: MatPaginator;
  @ViewChild("sortTracking") sortTracking!: MatSort;
  dsTracking!: MatTableDataSource<any>;
  colsTracking: string[] = ['check','box_id', 'id_ext', 'zona', 'sucursal', 'consecutivo', 'tracking_number', 'estatus', 'recibio', 'paqueteria', 'fecha_entrega', 'fecha_ultima_act', 'nuevaDireccion', 'actions'];

  guias_compradas: number = 0;
  total_guias: number = 0;
  total_cajas: number = 0;
  error_guias: number = 0;
  total_locales: number = 0;
  datos_envio: any = [];
  camp_id: number = 0;
  isLoadingShipments = false;
  progress: number = 0;
  deteniendo_compra : boolean = false;
  procesando: any = [];
  selectedItems: any[] = [];

  fechaInicio: Date | null = null;
  fechaFin: Date | null = null;
  rowsDias: any[] = [];
  flagData: boolean = false;

  cambiosCajaEncintar = false;

  zonasTracking: any = [];
  statusTracking: any = [];
  paqueteriasTracking: any = [];
  zonaSeleccionada: string = '';
  statusSeleccionado: string = '';
  paqueteriaSeleccionado: string = '';

  editingCell: { row: number | null, col: string | null } = { row: null, col: null };
  public filtroTrack = {
    search: '',
    zona: '',
    status: '',
    paqueteria: ''
};

  isExporting = false;

  /** Control para el selector de *carriers*. */
  carrControl: FormControl = new FormControl([]);
  /** El catálogo de nombres de *carriers* y servicios.*/
  catalog!: Catalog;
  /** Los pedidos que no tienen *providers* ni *carriers* todavía. */
  pending: number = 0;
  /** Control para el selector de *providers*. */
  provControl: FormControl = new FormControl([]);
  /** Arreglo transitorio para la interpretación diversa de respuestas de la DB. */
  pseudoData: Array<{ carrier: string, id: number, provider: string, service: 'Aéreo' | 'Terrestre' }> = [];
  /** La información para los filtros de selectores. */
  select: SDSelectorData = { carriers: [], carrDepn: [], providers: [], services: [], servDepn: [] };
  /** La información mostrada en los selectores. */
  selector: { carriers: Array<string>, providers: Array<string>, services: Array<string> } = { carriers: [], providers: [], services: [] };
  /** Control para el selector de *services*. */
  servControl: FormControl = new FormControl([]);
  /** La información que se va a mostrar en el *showcase* superior. */
  showcaseData: Array<SDShowcaseEntry> = [];

  isDistLoaded = false;
  isMfLoaded = false;
  isDatosEnvioLoaded = false;
  isGuiasLoaded = false;
  isTrackingLoaded = false;

  selectedRows: any[] = [];

  constructor(
    private distService : DistributionsService,
    private campaignS: CampaignsService,
    private main : MainService,
    private _params: ActivatedRoute,
    private _router : Router,
    private matDialog: MatDialog,
    private dialogQrValidation: MatDialog,
    private dialogPeriodos: MatDialog,
    private http: HttpClient,
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef
  ) { 
    this._params.params.subscribe(params => {
      if(params["id"]){
        this.loadCampaignData(params["id"]);
        this.camp_id = params["id"];
      }else{
        this._router.navigateByUrl('/admin/monitoring');
      } 
    });
  }
   ngOnInit(): void {
    this.updateColsSh();
  }

  //Quita el form field wrapper despues de cargar contenido
  ngAfterViewInit(): void {
    const style = this.renderer.createElement('style');
    style.innerHTML = `
      .input-form-field .mat-mdc-form-field-subscript-wrapper {
        display: none !important;
      }
    `;
    this.renderer.appendChild(document.head, style);
  }
  
  applyFilter(event: Event, ds: any) {
    const filterValue = (event.target as HTMLInputElement).value;
    ds.filter = filterValue.trim().toLowerCase();
    if (ds.paginator) ds.paginator.firstPage();
  }

  loadCampaignData(camp_id: any){
    this.campaignS.getCampaign(camp_id).subscribe(
      (result : any) => {
        if(result.data) {
          this.campana = result.data[0];
          this.loadDistData(this.campana.id);
          this.loadGeneralData(this.campana.id);
          //this.fillShowcase();
        }
      },
      (err : any) => {
        console.log(err);
      }
    );
  }
  
  loadDistData(camp_id: any){
    this.distService.getSucBgs(camp_id).subscribe(
      (result : any) => {
        if(result.data) {
          if(result.data.sucursales) {
            this.dsSucursales = new MatTableDataSource(result.data.sucursales);
            this.dsSucursales.paginator = this.paginator;
            this.dsSucursales.sort = this.sort;
            this.total_cajas = result.data.sucursales.length;

            result.data.bg.map((e:any)=> { 
              const status_txt = e.status==1?"En existencia":(e.status==2?"Faltante":"Retirar de linea");
              const pendiente = e.cantidad - e.recibido;
              const actual = e.recibido - e.empacado;
              return Object.assign(e, {status_txt, pendiente, actual});
            })
            this.dsBGs = new MatTableDataSource(result.data.bg);
            this.dsBGs.paginator = this.paginatorBG;
            this.dsBGs.sort = this.sortBG;

            this.dsRacks = new MatTableDataSource(result.data.racks);
            this.dsRacks.paginator = this.paginatorRK;
            this.dsRacks.sort = this.sortRK;
            
            result.data.materiales.map((e:any)=> { 
              const status_txt = e.status==1?"En existencia":(e.status==2?"Faltante":"Retirar de linea");
              const pendiente = e.cantidad - e.recibido;
              const actual = e.recibido - e.empacado;
              return Object.assign(e, {status_txt, pendiente, actual});
            })
            this.dsMaterials = new MatTableDataSource(result.data.materiales);
            this.dsMaterials.paginator = this.paginatorMat;
            this.dsMaterials.sort = this.sortMat;

            this.isDistLoaded = true;

          }
        }
      },
      (err : any) => {
        console.log(err);
      }
    );
  }

  onTabChanged(ev: any) {
    let selected_tab = ev.index;
    
      switch (selected_tab) {
      case 0:
        if (!this.isDistLoaded) {
          this.loadGeneralData(this.campana.id);
        }
        break;
      case 1: 
        if (!this.isDistLoaded) {
          this.loadDistData(this.campana.id);
        }
        break;
      case 2:
        if (!this.isDistLoaded) {
          this.loadDistData(this.campana.id);
        }
        break;
      case 3: 
        if (!this.isDistLoaded) {
          this.loadDistData(this.campana.id);
        }
        break;
      case 4: 
        if (!this.isDistLoaded) {
          this.loadDistData(this.campana.id);
        }
        break;
      case 5: 
        if(!this.isMfLoaded){
          this.loadListMf()
          this.isMfLoaded = true
        }
        break;
      case 6:
        if(!this.isDatosEnvioLoaded){
          this.loadListSh();
          this.isDatosEnvioLoaded = true;
        } 
        break;
      case 7:
        if(!this.isGuiasLoaded){
          this.loadFilesGuias(this.campana.id);
          this.isGuiasLoaded = true;
        } 
        break;
      case 8:
        if(!this.isTrackingLoaded){
          this.loadListSh();
          this.loadTracking(this.campana.id);
          this.isDatosEnvioLoaded = true;
          this.isTrackingLoaded = true;
        } 
        break;
    }
    
  }

  loadListMf(){
    this.distService.getMf(this.campana.id).subscribe(
      (result : any) => {
        if(result.data) {
          this.dsMf = new MatTableDataSource(result.data);
          this.dsMf.paginator = this.paginatorMf;
          this.dsMf.sort = this.sortMf;
        }
      },
      (err : any) => {
        console.log(err);
      }
    );
  }
  
  loadListSh(){
    this.distService.getDisShipmentData(this.campana.id).subscribe(
      (result : any) => {
        if(result.data) {
          this.datos_envio = result.data;
          this.guias_compradas = result.data.filter((e:any)=>e.status=="success").length;
          this.error_guias = result.data.filter((e:any)=>e.status=="error").length;
          this.total_locales = result.data.filter((e:any)=>e.carriers.toLowerCase()=="local").length;
          this.total_guias = result.data.length;
          this.progress = Math.floor((this.guias_compradas * 100) / (this.total_guias - this.total_locales));
          this.dsSh = new MatTableDataSource(this.datos_envio);
          this.dsSh.sort = this.sortSh;
          this.dsSh.paginator = this.paginatorSh;
          this.fillShowcase();
        }
      },
      (err : any) => {
        console.log(err);
      }
    );
  }

  
  stopGetLabels() {
    this.deteniendo_compra = true;
    Swal.fire({
      icon: 'info',
      title: 'Deteniendo proceso...',
      allowEscapeKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
  }

async loadGetLabels() {
  const confirmation = await Swal.fire({
    title: '¿Estás seguro de que deseas comprar las guías?',
    text: 'Esta acción iniciará el proceso de compra de las guías pendientes.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Sí, comprar',
    cancelButtonText: 'Cancelar'
  });

  if (!confirmation.isConfirmed) {
    return;
  }

  this.distService.getBUConfig(this.campana.id).subscribe(
    (result: any) => {
      if (result.data) {
        let BUConfig = {
          carriers: null,
          group_attempts: 0,
          group_attempts_active: 0,
          guide_attempts: 0,
          guide_attempts_active: 0,
          providers: null
        };
        
        if (
          result.data &&
          (!Array.isArray(result.data) || (Array.isArray(result.data) && result.data.length > 0))
        ) {
          BUConfig = result.data;
        }

        let failedLabelsCount = 0;

        let arr_ids = this.datos_envio
          .filter((e: any) => e.status != "success" && e.status != "in_progress" && e.carriers.toLowerCase() != "local")
          .map((e: any) => e.id);
        let resultado = [];

        for (var i = 0; i < arr_ids.length; i += 50) {
          resultado.push(arr_ids.slice(i, i + 50));
        }
        this.getLabels(resultado, 0, BUConfig, failedLabelsCount);
      }
    },
    (err: any) => {
      console.log(err);
    }
  );
}
  
  getLabels(arr: any, i: number, BUConfig: any, failedLabelsCount: number) {
    this.procesando = arr[i];
    this.isLoadingShipments = true;
    this.distService.getLabels(this.camp_id, arr[i]).subscribe(
      (result : any) => {
        if(result.data) {
          this.datos_envio = this.datos_envio.map((e:any)=> {
            const obj_res = result.data.find((d:any)=> d.id==e.id);
            return Object.assign(e, { status: e.status!="success"?obj_res?.status:e.status, label: e.status!="success"?obj_res?.label:e.label });
          });

          this.guias_compradas = this.datos_envio.filter((e:any)=>e.status=="success").length;
          this.error_guias = result.data.filter((e:any)=>e.status=="error").length;
        }
        try{
          failedLabelsCount += result.failed_labels_count || 0;
        }catch(e) {
          console.log(e);
        }
        if(result?.stop_retry_process || (failedLabelsCount > BUConfig.group_attempts && BUConfig.group_attempts_active)) {
          this.loadListSh();
          let message =  result.stop_retry_process ? 'Se ha detenido el proceso porque se excedió el límite de intentos por guía.' : 'Se ha detenido el proceso porque se excedió el límite de fallos permitidos.';
          Swal.fire({
            icon: 'warning',
            title: 'Proceso detenido',
            text: message
          });
          this.isLoadingShipments = false;
        }else{
          if(!this.deteniendo_compra) {
            if((i+1) < arr.length) {
              this.progress = Math.floor((this.guias_compradas * 100) / (this.total_guias - this.total_locales));
              this.getLabels(arr, (i+1), BUConfig, failedLabelsCount);
            }
            else {
              this.progress = 100;
              this.loadListSh();
              Swal.fire({
                icon: 'success',
                title: 'Proceso finalizado',
                text: '¡Proceso de compra finalizado!'          
              });
              this.isLoadingShipments = false;
            }
          }
          else {
            this.loadListSh();
            Swal.fire({
              icon: 'success',
              title: 'Proceso detenido',
              text: 'Proceso de compra detenido por el usuario.'
            });
            this.isLoadingShipments = false;
          }
        }
        this.procesando = [];
      },
      (err : any) => {
        console.log(err);
        this.loadListSh();
        Swal.fire({
          icon: 'success',
          title: 'Proceso detenido',
          text: 'Proceso de compra detenido por el sistema.'
        });
        this.isLoadingShipments = false;
      }
    );
  }

  activateExporting(){
    // Guarda los datos originales
    this.originalDsShData = this.dsSh.data;
    // Filtra solo los errores
    this.dsSh.data = this.originalDsShData.filter((row: any) => row.status === 'error');
    this.isExporting = true;
    this.updateColsSh();
    this.cdr.detectChanges();
  }

  deactivateExporting(){
    setTimeout(() => {
      // Restaura los datos originales
      this.dsSh.data = this.originalDsShData;
      this.isExporting = false;
      this.updateColsSh();
      this.cdr.detectChanges();
    }, 2000);
  }

  updateColsSh() {
  if (this.isExporting) {
    this.colsSh = this.colsShBase.filter(col => col !== 'actions');
  } else {
    this.colsSh = [...this.colsShBase];
  }
}


  openBulkConfig() {
    this.matDialog.open(BulkConfig, {
      panelClass: ['dialogs-lg'],
      data: {
        campaign : this.campana
      }
    }).afterClosed().subscribe(
      resp => {
        if(resp?.reload) {
          this.loadCampaignData(this.campana.id);
          this.tab.selectedIndex = 0;
        }
      }
    );
  }

  changeMatStatus(row: any, status: number, type: string){
    const camp_id = this.campana.id;
    const id = row.id;
    Swal.fire({
      title: '¿Estás seguro que deseas modificar el estatus del material?',
      icon: 'warning',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: `Confirmar`,
      cancelButtonText: `Cancelar`
    }).then((result) => {      
      if (result.isConfirmed && ["mat", "bg"].includes(type)) {
        this.distService.changeMatStatus(camp_id, id, status, type).subscribe(
          (result : any) => {
            if(result.message == "Success") {
              Swal.fire({
                icon: 'success',
                title: 'Guardado',
                text: 'Estatus actualizado de manera correcta!'          
              });
              this.loadDistData(this.campana.id);
              if(type == "mat") this.tab.selectedIndex = 4;
              if(type == "bg") this.tab.selectedIndex = 2;
            }
          },
          (err : any) => {
            console.log(err);
            Swal.fire({
              icon: 'error',
              title: 'Error al guardar',
              text: 'Ocurrió un error al guardar el registro, por favor vuelve a intentarlo.'
            });
          }
        );
      }
    });
  }

  
  generateShipmentsFile(){
    const camp_id = this.campana.id;
    Swal.fire({
      title: '¿Estás seguro que deseas generar el archivo de guias?',
      icon: 'warning',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: `Confirmar`,
      cancelButtonText: `Cancelar`
    }).then((result) => {      
      if (result.isConfirmed) {
        Swal.fire({
          icon: 'info',
          title: 'Generando archivo...',
          allowEscapeKey: false,
          allowOutsideClick: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });
        this.distService.generateShipmentsFile(camp_id).subscribe(
          (result : any) => {
            if(result.message == "Success") {
              window.open(result.data, "_blank");
              Swal.fire({
                icon: 'success',
                title: 'Archivo creado',
                text: 'Archivo generado de manera correcta!'
              });
            }
          },
          (err : any) => {
            console.log(err);
            Swal.fire({
              icon: 'error',
              title: 'Error al generar',
              text: 'Ocurrió un error al generar el archivo de guias, por favor vuelve a intentarlo.'
            });
          }
        );
      }
    });
  }

  downloadFileDistData(){
    this.distService.getFileSucBgs(this.campana.id).subscribe(
      (result : any) => {
        if(result.data) {
          window.open(result.data, "_blank");
        }
      },
      (err : any) => {
        console.log(err);
      }
    );
  }

  openUploadDist(){
    this.matDialog.open(DistributionUploadFileComponent, {
      panelClass: ['dialogs-lg'],
      data: {
        campaign : this.campana
      }
    }).afterClosed().subscribe(
      resp => {
        if(resp?.reload) this.loadCampaignData(this.campana.id);
      }
    );
  }

  openUploadRackDist(){
    this.matDialog.open(DistributionUploadRacksFileComponent, {
      panelClass: ['dialogs-lg'],
      data: {
        campaign : this.campana
      }
    }).afterClosed().subscribe(
      resp => {
        if(resp?.reload) this.loadCampaignData(this.campana.id);
      }
    );
  }

  openUploadGuides(){
    this.matDialog.open(DistributionUploadGuidesFileComponent, {
      panelClass: ['dialogs-sm'],
      data: {
        campaign : this.campana
      }
    }).afterClosed().subscribe(
      resp => {
        if(resp?.data) window.open(resp.data, "_blank");
      }
    );
  }

  openUploadOrderedGuides(){
    this.matDialog.open(DistributionUploadOrderedGuidesComponent, {
      panelClass: ['dialogs-sm'],
      data: {
        campaign : this.campana
      }
    }).afterClosed().subscribe(
      resp => {
        if(resp?.data){
          //window.open(resp.data, "_blank");
          this.loadFilesGuias(this.campana.id)
        } 
      }
    );
  }

  openUploadMaterialImgs(){
    this.matDialog.open(DistributionMaterialsUploadImgsComponent, {
      panelClass: ['dialogs-sm'],
      data: {
        campaign : this.campana
      }
    }).afterClosed().subscribe(
      resp => {
        if(resp?.reload) {
          this.loadCampaignData(this.campana.id);
          this.tab.selectedIndex = 4;
        }
      }
    );
  }

  openDialogMaterialList(row:any) {
    this.matDialog.open(BoxMaterialsListComponent, {
      panelClass: ['dialogs-main'],
      data: {
        box : row
      }
    }).afterClosed().subscribe(
      resp => {
      }
    );
  }

  openDialogBGMaterialList(row:any) {
    this.matDialog.open(BgMaterialsListComponent, {
      panelClass: ['dialogs-main'],
      data: {
        bg : row
      }
    }).afterClosed().subscribe(
      resp => {
      }
    );
  }

  openDialogRackMaterialList(row:any) {
    this.matDialog.open(RackMaterialsListComponent, {
      panelClass: ['dialogs-main'],
      data: {
        rack : row
      }
    }).afterClosed().subscribe(
      resp => {
      }
    );
  }

  openDialogSaveMf() {
    this.matDialog.open(MfAddComponent, {
      panelClass: ['dialogs-lg'],
      data: {
        id_campana : this.campana.id
      }
    }).afterClosed().subscribe(
      resp => {
        if(resp?.reload)  {
          this.loadListMf(); 
          this.tab.selectedIndex = 5;
        }
      }
    );
  }

  openDialogDocMf(row:any) {
    this.matDialog.open(MfDocComponent, {
      panelClass: ['dialogs-main'],
      data: {
        id_campana : this.campana.id,
        mf: row
      }
    }).afterClosed().subscribe(
      resp => {
        if(resp?.reload)  {
          this.loadListMf(); 
          this.tab.selectedIndex = 5;
        }
      }
    );
  }

  openDialogCloseBox() {
    this.matDialog.open(CloseBoxesComponent, {
      panelClass: ['dialogs-lg'],
      data: {
        id_campana : this.campana.id
      }
    }).afterClosed().subscribe(
      resp => {
      }
    );
  }

  openUploadDistShipmentData(){
    this.matDialog.open(DistributionUploadShipmentsFileComponent, {
      panelClass: ['dialogs-main'],
      data: {
        campaign : this.campana
      }
    }).afterClosed().subscribe(
      resp => {
        if(resp?.reload) this.loadListSh();
      }
    );
  }

  openEditDistShipmentData(row: any){
    this.matDialog.open(DistributionEditShipmentDataComponent, {
      panelClass: ['dialogs-main'],
      data: {
        shipment : row,
        id_campana : this.campana.id
      }
    }).afterClosed().subscribe(
      resp => {
        if(resp?.reload) this.loadListSh();
      }
    );
  }
  
  openDialogMaterialIgs(row:any) {
    console.log("OPEN MODAL")
    console.log(row)
    this.matDialog.open(DistributionMaterialsImgSlidersComponent, {
      panelClass: ['dialogs-lg'],
      data: {
        material : row
      }
    }).afterClosed().subscribe(
      resp => {
      }
    );
  }

  openDialogValidationQr(element: any, tipo: number): void {

    //Tipo 1 = Material, Tipo 2 = Bolsa
    console.log("Element cuando abre modal QR");
    console.log(element)
  
    const dialogRef = this.dialogQrValidation.open(ValidationQrComponent, {
      panelClass: 'dialogs-sm',
      data: element 
    });

    dialogRef.afterClosed().subscribe(result => {

      // Guarda o edita
      if(result.delete == 0){
        if (result) {

          element.tipo_validacion = result.option; 
          element.max_length = result.maxLength; 
          element.min_length = result.minLength; 
          element.bitUnico = result.unico; 
          element.arreglo = result.arreglo.join(); 
  
          result.arreglo = result.arreglo.length == 0  ? null : result.arreglo.join(',');
          result.minLength = result.minLength == ''  ? null : result.minLength;
          result.maxLength = result.maxLength == ''  ? null : result.maxLength;
  
          const newRecord = {
            idCampana: this.camp_id,
            idMaterial: element.id,
            selectedOption : result.option,
            optionsArreglo: result.arreglo,
            esUnico: result.unico,
            minLength: result.minLength,
            maxLength: result.maxLength,
            idValidation: element.idValidation ?? 0,
            tipo: tipo
          };
  
          this.campaignS.setValidationQr(newRecord).subscribe(
            (result:any)=>{
              if(result.message == 'Success') {
                Swal.fire({
                  icon: 'info',
                  title: 'Guardado',
                  text:'',
                  allowEscapeKey: false,
                  allowOutsideClick: false,
                  showConfirmButton: false,
                  timer: 1000,
                });   
              }
              else {
                Swal.fire({
                  icon: 'error',
                  title: 'Error al guardar',
                  text: 'Ocurrió un error, favor de informar al equipo de soporte.',
                  timer: 3000,
                  showConfirmButton: false
                });
              }
              element.idValidation = result.id;
            },
            (err:any)=>{
              this.main.HideLoading();
              Swal.fire({
                icon: 'error',
                title: 'Error al guardar',
                text: 'Ocurrió un error, favor de informar al equipo de soporte.',
                timer: 3000,
                showConfirmButton: false
              });
          });
        }
      }
      // Elimina
      else if(result.delete == 1){

        Swal.fire({
          icon: 'warning',
          title: '¿Seguro que quieres desactivar la validación?',
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonText: 'Sí, desactivar',
          cancelButtonText: 'Cancelar',
          customClass: {
            confirmButton: 'custom-confirm-button',
          },
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then((resultSwal) => {

          const objValidation = { id: result.idValidation} ;
          if (resultSwal.isConfirmed) {
            this.campaignS.setDeleteValidacionQr(objValidation).subscribe(
              (resultS:any)=>{
                if(resultS.message == 'Success') {
                  Swal.fire({
                    icon: 'info',
                    title: 'Guardado',
                    text:'',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    timer: 1000,
                  });   
                  element.tipo_validacion = null; 
                  element.max_length = null; 
                  element.min_length = null; 
                  element.bitUnico = null; 
                  element.arreglo = null;
                  element.idValidation = null;
                }
                else {
                  Swal.fire({
                    icon: 'error',
                    title: 'Error al guardar',
                    text: 'Ocurrió un error, favor de informar al equipo de soporte.',
                    timer: 3000,
                    showConfirmButton: false
                  });
                }
              },
              (err:any)=>{
                this.main.HideLoading();
                Swal.fire({
                  icon: 'error',
                  title: 'Error al guardar',
                  text: 'Ocurrió un error, favor de informar al equipo de soporte.',
                  timer: 3000,
                  showConfirmButton: false
                });
            });
          }
        });

        
      }
          
    });
  }

  loadFilesGuias(camp_id: any){
    this.distService.getFilesGuides(camp_id).subscribe(
      (result : any) => {
        if(result.data) {
          
          result.data.map((e:any)=> { 
            const elements = e.consecutivos.split(",");
            const total_guias = elements.length;
            return Object.assign(e, {total_guias});
          })

          this.dsArchivos = new MatTableDataSource(result.data);
          this.dsArchivos.paginator = this.paginatorFiles;
          this.dsArchivos.sort = this.sortFiles;

        }
      },
      (err : any) => {
        console.log(err);
      }
    );
  }

  setPrint(row: any) {
    this.distService.setPrintFile(row.id)
      .subscribe(
        (response: any) => {
          row.print = 1;
          const fileURL = URL.createObjectURL(response); // Crea una URL temporal para el archivo
          // @ts-ignore
          printJS({ printable: fileURL, type: 'pdf' }); // Llama a Print.js para imprimir el PDF
        },
        (error: any) => {
          console.error('Error descargando el archivo:', error);
        }
      );
  }

  validaDataGeneral() {
    if (!this.fechaInicio || !this.fechaFin) {
      Swal.fire({
        icon: 'warning',
        title: 'Campos incompletos',
        text: 'Por favor, selecciona ambas fechas para continuar.',
        confirmButtonText: 'Ok',
      });
      return;
    }

    const inputsCajas = this.rowsDias.some(row => !row.cajas || row.cajas <= 0)

    if(inputsCajas){
      Swal.fire({
        icon: 'warning',
        title: 'Campos incompletos',
        text: 'Por favor, ingresa un número total en cajas a encintar.',
        confirmButtonText: 'Ok',
      });
      return;
    }

    if(this.flagData == true){
      Swal.fire({
        title: "Atención",
        text: "Se detectaron objetivos anteriormente guardados, ¿seguro que quieres actualizarlos?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, confirmar",
        cancelButtonText: "Cancelar"
        }).then((result) => {
            if (result.isConfirmed) {
              this.saveDataGeneral()
            }
        });
    }
    if(this.cambiosCajaEncintar){
      Swal.fire({
        title: "Atención",
        text: "Se detectaron cambios en los objetivos, por lo cual se eliminarán los periodos registrados anteriormente, ¿seguro que quieres continuar?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, confirmar",
        cancelButtonText: "Cancelar"
        }).then((result) => {
            if (result.isConfirmed) {
              this.saveDataGeneral()
            }
        });
    }
    else{
      this.saveDataGeneral()
    }
 
  }

  saveDataGeneral(){
    const data = {
      id_campana: this.camp_id,
      fechaInicio: this.fechaInicio,
      fechaFin: this.fechaFin,
      flagData: this.flagData,
      rows: this.rowsDias,
      cambiosCajaEncintar: this.cambiosCajaEncintar
    };

    this.mostrarLoading();
    this.distService.setDataGeneralCampaign(data).subscribe(
        (response: any) => {
          Swal.close(); // Cerrar loading
          if(response.message == "Success") {
            Swal.fire({
              icon: 'success',
              title: 'Guardado',
              text: ''          
            });
            this.rowsDias = response.data;
            this.dsGeneral = new MatTableDataSource(this.rowsDias);
            this.cambiosCajaEncintar = false;
            this.campana.fecha_inicio = this.fechaInicio;
            this.campana.fecha_fin = this.fechaFin;

            this.loadCampaignData(this.camp_id);

          }
        },
        (error: any) => {
          Swal.close(); // Cerrar loading
          console.error('Error al guardar:', error);
          Swal.fire({
            icon: 'error',
            title: 'Error al guardar',
            text: 'Ocurrió un error al guardar el registro, por favor vuelve a intentarlo.'
          });
        }
    );
  }

  calcularDias() {
    if (!this.fechaInicio || !this.fechaFin) {
      return;
    }

    const start = new Date(this.fechaInicio);
    const end = new Date(this.fechaFin);
    let currentDate = start;

    if (end < start) {
      Swal.fire({
        icon: 'warning',
        title: 'Advertencia',
        text: 'La fecha de fin debe ser posterior a la fecha de inicio.',
        confirmButtonText: 'Ok',
      });
      return;
    }

    //Para saber si ya se guardaron objetivos
    if(this.rowsDias?.[0]?.idObjetivo ?? 0 > 0){
      Swal.fire({
        title: "Atención",
        text: "Ya existe información en objetivos, ¿seguro que quieres sobreescribir los datos en pantalla?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, confirmar",
        cancelButtonText: "Cancelar"
        }).then((result) => {
            if (result.isConfirmed) {
              this.flagData = true;
              this.llenarObjetivos(currentDate,end)
            }
        });
    }
    else{
      this.llenarObjetivos(currentDate,end)
    }

  }


  llenarObjetivos(currentDate: any, end:any){
    this.rowsDias = [];

    while (currentDate <= end) {
      this.rowsDias.push({
        fecha: new Date(currentDate),
        cajas: 0,
        idObjetivo: 0,
        numPeriodos: 0
      });

      // Avanzar al siguiente día
      currentDate.setDate(currentDate.getDate() + 1);
    }

    //Si hay cajas en la campaña
    if(this.dsSucursales != undefined){

      const distribucionCajas = this.distribuirCajas(this.dsSucursales.filteredData.length, this.rowsDias.length);
      //Se actualiza el numero de cajas
      this.rowsDias.map((e:any, index: number) => {
        e.cajas = distribucionCajas[index];
      })
    }

    this.dsGeneral = new MatTableDataSource(this.rowsDias);
  }

  loadGeneralData(camp_id: any){
    this.distService.getGeneralData(camp_id).subscribe(
      (result : any) => {
        if(result.data) {

          this.rowsDias = result.data;

          const fechaOriginal1 = this.campana.fecha_inicio;
          const fechaOriginal2 = this.campana.fecha_fin;

          if(fechaOriginal1 != null){
            const [year, month, day] = fechaOriginal1.split('-').map(Number);
            const fecha1 = new Date(year, month - 1, day);
  
            const [year2, month2, day2] = fechaOriginal2.split('-').map(Number);
            const fecha2 = new Date(year2, month2 - 1, day2);
  
            this.fechaInicio = fecha1;
            this.fechaFin = fecha2;
          }
  
          this.dsGeneral = new MatTableDataSource(this.rowsDias);

        }
      })
  }
          
  downloadCajas(){
    this.distService.getFileCajas(this.campana.id).subscribe(
      (result : any) => {
        if(result.data) {
          window.open(result.data, "_blank");
        }
      },
      (err : any) => {
        console.log(err);
      }
    );
  }

  openDialogPeriodos(element: any): void {

     if (this.cambiosCajaEncintar == true) {
          Swal.fire({
            icon: 'warning',
            title: 'Atención',
            text: 'Se detectaron cambios en las cajas a encintar, primero guarde los objetivos para continuar.',
            confirmButtonText: 'Ok',
          });
      }
      else{
        element.campana = this.camp_id;
  
        const dialogRef = this.dialogPeriodos.open(PeriodosComponent, {
          panelClass: 'dialogs-md',
          data: element 
        });

        dialogRef.afterClosed().subscribe(result => {
          this.loadCampaignData(this.campana.id);
          //this.loadGeneralData(element.campana)
        });
      }

  }

  distribuirCajas(totalCajas: number, numeroDias: number) {
  
    const cajasPorDia = Math.floor(totalCajas / numeroDias);
    const resto = totalCajas % numeroDias;

    // Crear un array para almacenar la distribución de cajas
    const distribucion = Array(numeroDias).fill(cajasPorDia);

    // Distribuir las cajas sobrantes
    for (let i = 0; i < resto; i++) {
        distribucion[i]++;
    }

    return distribucion;
  }

  mostrarLoading() {
    Swal.fire({
      title: 'Guardando...',
      text: 'Por favor, espera.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
  }

  mostrarLoadingSync() {
    Swal.fire({
      title: 'Actualizando...',
      text: 'Por favor, espera.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
  }

  downloadBolsas(){
    this.distService.getFileBolsas(this.campana.id).subscribe(
      (result : any) => {
        if(result.data) {
          window.open(result.data, "_blank");
        }
      },
      (err : any) => {
        console.log(err);
      }
    );
  }

  downloadMateriales(){
    this.distService.getFileMateriales(this.campana.id).subscribe(
      (result : any) => {
        if(result.data) {
          window.open(result.data, "_blank");
        }
      },
      (err : any) => {
        console.log(err);
      }
    );
  }

  validateInput(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault(); // Evita que se escriban letras o caracteres especiales
    }
  }

  onCajasChange(): void {
    this.cambiosCajaEncintar = true;
  }
  
  loadTracking(camp_id: any){
    this.distService.getDistTracking(camp_id).subscribe(
      (result : any) => {
        if(result.data) {
                    
          this.dsTracking = new MatTableDataSource(result.data);
          this.dsTracking.paginator = this.paginatorTracking;
          this.dsTracking.sort = this.sortTracking;

          this.zonasTracking = result.zonas;
          this.statusTracking = result.status;
          this.paqueteriasTracking = result.paqueterias;

          this.dsTracking.filterPredicate = (data: any, filter: string) => {
            const filters = JSON.parse(filter);
            const searchFilter = filters.search || '';

            const coincideZona = !filters.zona || data.zona?.toLowerCase() === filters.zona;
            const coincideStatus = !filters.status || data.estatusNew?.toLowerCase() === filters.status;
            const coincidePaqueteria = !filters.paqueteria || data.paqueteria?.toLowerCase() === filters.paqueteria;
            
            const coincideTexto = JSON.stringify(data).toLowerCase().includes(searchFilter);

            return coincideZona && coincideStatus && coincidePaqueteria && coincideTexto;
          };
          this.aplicarFiltros();
        }
      },
      (err : any) => {
        console.log(err);
      }
    );
  }

  applyFilterTracking(event: Event, ds: any) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filtroTrack.search = filterValue.trim().toLowerCase();
    this.aplicarFiltros();
  }

  openDialogEditTracking(row:any, type: number) {

    let newArray;
    if(type == 1){
      if(row.fecha_entrega != null){
        const [year, month, day] = row.fecha_entrega.split('-').map(Number);
        row.fecha_entrega = new Date(year, month - 1, day); //para que ponga fecha correcta en el datepicker
      }
      
      newArray = row;
    }
    else{
      newArray = [...this.selectedItems];
    }

    newArray = JSON.parse(JSON.stringify(newArray))   

    this.matDialog.open(DistributionEditTrackingComponent, {
      panelClass: ['dialogs-sm'],
      data: {
        newArray,
        carriers: this.selector.carriers
      }
    }).afterClosed().subscribe(
      resp => {
        if(resp.saved == 1){
          Swal.fire({
            icon: 'success',
            title: 'Guardado',
            text: 'Información guardada correctamente'          
          });
          //this.dsTracking.data.forEach(item => item.checked = false);
          this.loadTracking(this.campana.id)
          
          
        }

        this.selectedItems = [];

        
      }
    );
  }

  onCheckboxChange(event: any, row: any) {
    if (event.checked) {
      this.selectedItems.push(row);
    } else {
      this.selectedItems = this.selectedItems.filter(r => r.box_id !== row.box_id);
    }
  }

  isSelected(row: any): boolean {
    return this.selectedItems.some(r => r.box_id === row.box_id);
  }


  downloadTracking(){
    this.distService.getFileTracking(this.campana.id).subscribe(
      (result : any) => {
        if(result.data) {
          window.open(result.data, "_blank");
        }
      },
      (error : any) => {
        console.log(error);
      }
    );
  }

  syncTracking(){
    this.mostrarLoadingSync();
    this.campaignS.updateTracking(this.campana.id).subscribe(
      (result:any) => {
        if (result.status == "success") {
          //se vacia la tabla
          this.dsTracking = new MatTableDataSource();
          this.loadTracking(this.campana.id);
          Swal.fire({
                icon: 'success',
                title: 'Actualizado'
              }).then(() => {
            });
          }
      },
      (err: any) => {
        console.log(err);
        Swal.fire({
          icon: 'error',
          title: 'Error al actualizar',
          text: 'Ocurrió un error al actualizar el registro, por favor vuelva a intentarlo.'
        });
      }
    );
  }


  openDialogPreviewMf(row:any) {
    this.matDialog.open(MfPreviewComponent, {
      panelClass: ['dialogs-lg'],
      data: {
        id_campana : this.campana.id,
        mf: row      
      }
    }).afterClosed().subscribe(
      resp => {
        this.loadListMf(); 
        this.tab.selectedIndex = 5;
    })
  }
  filtrarPorZona(zona: string) {
    this.filtroTrack.zona = (zona ?? '').trim().toLowerCase();
    this.aplicarFiltros();
  }

  filtrarPorStatus(status: string) {
    this.filtroTrack.status = (status ?? '').trim().toLowerCase();
    this.aplicarFiltros();
  }

  filtrarPorPaqueteria(paqueteria: string) {
    this.filtroTrack.paqueteria = (paqueteria ?? '').trim().toLowerCase();
    this.aplicarFiltros();
  }

  aplicarFiltros() {
    const filtroTrack = {
      search: this.filtroTrack.search,
      zona: (this.filtroTrack.zona ?? '').trim().toLowerCase(),
      status: (this.filtroTrack.status ?? '').trim().toLowerCase(),
      paqueteria: (this.filtroTrack.paqueteria ?? '').trim().toLowerCase()
    };

    this.dsTracking.filter = JSON.stringify(filtroTrack);
    if (this.dsTracking.paginator) this.dsTracking.paginator.firstPage();
    this.selectedItems = [];
  }

  toggleAllRows(event: MatCheckboxChange) {
    const isChecked = event.checked;

    this.dsTracking.filteredData.forEach(row => {
      row.checked = isChecked;

      // Agregar o quitar del array selectedItems
      if (isChecked && !this.isSelected(row)) {
        this.selectedItems.push(row);
      } else if (!isChecked) {
        this.selectedItems = this.selectedItems.filter(r => r.id !== row.id);
      }
    });
  }

  isAllSelected(): boolean {
    if (!this.dsTracking) return false;
    return this.dsTracking.filteredData.length > 0 && this.dsTracking.filteredData.every(row => this.isSelected(row));
  }

  isIndeterminate(): boolean {
    if (!this.dsTracking) return false;
    const selected = this.dsTracking.filteredData.filter(row => this.isSelected(row));
    return selected.length > 0 && selected.length < this.dsTracking.filteredData.length;
  }

  activateVisualizar(bitVisualizar: number){
    let actionBit = bitVisualizar == 1 ? 0 : 1;
    Swal.fire({
          icon: 'info',
          title: 'Espere...',
          allowEscapeKey: false,
          allowOutsideClick: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading();
          }
    });
    this.campaignS.changeStatusVisualizar(this.campana.id, actionBit).subscribe(
          (result:any) => {
            if (result.message == "Success") {
              Swal.fire({
                icon: 'success',
                title: 'Actualizado'
              }).then(() => {
              });
            }
          },
          (err:any) => {
            Swal.fire({
              icon: 'error',
              title: 'Error al actualizar',
              text: 'Ocurrió un error al actualizar el registro, por favor vuelva a intentarlo.'
            });
          }
    );
  }


  /** Llena la información necesaria para el *showcase*. */
  async fillShowcase(): Promise<void> {
    // Limpiar la información
    this.showcaseData = [];
    this.select = { carriers: [], carrDepn: [], providers: [], services: [], servDepn: [] };
    this.pending = 0;

    // Si no se ha creado el catálogo, crearlo
    if (!this.catalog) {
      const x: any = await firstValueFrom(this.distService.getServicesCatalog());
      this.catalog = new Catalog(x.data, false);
    }

    // Crear pseudodata para conectar la información de la data al showcase
    this.pseudoData = this.datos_envio.map((x: any) => {
      const c: string = x.carriers?.trim() ?? '',
            p: string = x.providers?.trim() ?? 'any',
            s: string = x.service?.trim() ?? '';

      return { carrier: this.catalog.normalizeCarrier(c), id: x.id, provider: p.toLocaleUpperCase(), service: s.toLocaleUpperCase() };
    });

    // Llenar el arreglo con base en la data recibida.
    this.pseudoData.forEach((x: any) => {
      const carrier: string | null = x.carrier,
            provider: string | null = x.provider,
            service: string | null = x.service;

      // Añadir el tipo de servicio a la información de los selectores
      if (service && !this.select.services.includes(service)) this.select.services.push(service);
      
      // Si no tiene data, sigue pendiente
      if (this.noDataAvailable({ carrier: carrier, provider: provider })) { // || this.datos_envio.findIndex((i: any) => i.id === x.id && i.status.toLocaleLowerCase() === 'error') !== -1
        this.pending++;
        return;
      }

      // Encontrar el provider
      let p = this.showcaseData.find(y => y.provider === provider);

      if (!p) {
        // Si no está, crear uno nuevo
        this.showcaseData.push({
          data: [{ name: carrier! ?? '', qty: 1 }],
          provider: provider! ?? '',
          qty: 1
        });
        // ...y añadir los datos a las listas de selectores
        if (!this.select.carriers.includes(carrier!)) this.select.carriers.push(carrier!);
        this.select.providers.push(provider!);
      } else {
        // Sumar uno a la cantidad
        p.qty++;
        // Si existe, ver si existe el carrier
        let c = p.data.find(y => y.name === carrier);

        // Si existe el carrier, sumar uno a la cantidad. Si no, empujar uno nuevo.
        if (c) c.qty++;
        else p.data.push({ name: carrier ?? '', qty: 1 });

        // ...y añadir los datos a las listas de selectores
        if (!this.select.carriers.includes(carrier!)) this.select.carriers.push(carrier!);
      }
    });

    // Ordenar nombres
    this.select.carriers.sort();
    this.select.providers.sort();
    this.select.services.sort();
    this.showcaseData.forEach((x: SDShowcaseEntry) => { x.data.sort((a, b) => a.name.localeCompare(b.name)); });

    // Llenar matrices de dependencia
    this.fillDependencyMatrices();

    // Llenar la data de los selectores
    if (this.carrControl.value.length + this.provControl.value.length + this.servControl.value.length === 0)
      this.startSelectors();
  }

  /** Despliega el *dialog* para ver y editar los insumos de un material.
    * @param {number} id El ID del material del cual se van a revisar los insumos.
    * @param {string} name El nombre del material del cual se van a revisar los insumos.
    * @param {string | null} clist La lista de insumos que utiliza. */
  async openComponentsDialog(id: number, name: string, clist: string | null): Promise<void> {
    const reload = await firstValueFrom(this.matDialog.open(MaterialComponentsListComponent, {
      data: {
        components: clist ?? "[]",
        material: { id, name }
      },
      panelClass: ['dialogs-main']
    }).afterClosed());

    console.info("Reload:", reload);

    if (reload) {
      this.isDatosEnvioLoaded = false;
      this.isDistLoaded = false;
      this.isGuiasLoaded = false;
      this.isMfLoaded = false;
      this.isTrackingLoaded = false;
      this.loadCampaignData(this.campana.id);
    }
  }

  /** Despliega el *dialog* para ver y editar la configuración de un material.  
    * Antes: `openRellenoLinea(1)` */
  async openSettingsDialog(row: any): Promise<void> {
    await firstValueFrom(this.matDialog.open(MaterialsSettingsComponent, {
      data: { campaign: this.campana, ...row },
      panelClass: ['dialogs-lg']
    }).afterClosed());

    this.loadCampaignData(this.campana.id);
  }

  /** Inicia todos los selectores con todos los valores seleccionados. */
  startSelectors(): void {
    this.carrControl.setValue([...this.select.carriers], { emitEvent: false });
    this.provControl.setValue([...this.select.providers], { emitEvent: false });
    this.servControl.setValue([...this.select.services], { emitEvent: false });

    this.selector.carriers = this.select.carriers;
    this.selector.providers = this.select.providers;
    this.selector.services = this.select.services;
  }

  /** Filtra los valores de la tabla de acuerdo con los selectores. */
  toggleFilter(): void {
    const carrs: any = this.carrControl.value,
          provs: any = this.provControl.value,
          servs: any = this.servControl.value;

    // Filtrar por pseudodata
    const temp: any = this.pseudoData.filter((x: any) =>
      (carrs.includes(x.carrier)) && (provs.includes(x.provider)) && (servs.includes(x.service) || x.service == '')
    );

    // Construir un Set de IDs para buscar rápido
    const psFiltered: Set<any> = new Set(temp.map((x: any) => x.id));

    // Crear el filterPredicate
    this.dsSh.filterPredicate = (x: any, _: string) => {
      return psFiltered.has(x.id);
    }

    // Filtrar carriers en el selector
    this.selector.carriers = this.select.carriers.filter((_: any, i: number) => {
      return this.select.carrDepn[i].some(x => provs.includes(x));
    });

    // Filtrar servicios en el selector
    this.selector.services = this.select.services.filter((_: any, i: number) => {
      return this.select.servDepn[i][0].some(x => provs.includes(x)) && this.select.servDepn[i][1].some(x => carrs.includes(x));
    });

    // Aplicar el filtro
    this.dsSh.filter = 'Please';
  }

  /** Regresa el color que representa al *carrier* en el showcase.
    * @param {string} carrier - El nombre de la paquetería.
    * @returns {string} El código HEX del color. */
  colorFor(carrier: string): string {
    const carriers: Array<string> = ['afimex', 'big', 'dhl', 'estafeta', 'fedex', 'j&t', 'pex', 'paquetexpress', 'segmail', 'sendex', 'ups', '99m', 'buho'],
          code: Array<string> = ['#EA7A0B', '#C5A507', '#F6D013', '#A21F16', '#58007A', '#D72A1D', '#04078B', '#04078B', '#02033B', '#5A110C', '#141315', '#8ECA02', '#FF6E00'];
  
    const x = carriers.indexOf(carrier.toLocaleLowerCase());
    return x !== -1 ? code[x] : 'white';
  }

  /** Calcula el ancho que debe tener la tarjeta en el *showcase* para que se vea de la mejor manera posible.
    * @param {number} n - La cantidad de carriers que se mostrarán en la tarjeta.
    * @param {'m'|'w'} style - El atributo que se calculará.
    * @returns {string} El valor del ancho requerido. */
  width(n: number, style: 'm'|'w'): string {
    if (style[0] === 'm')
      return `${240 + ((n > 2) ? 60 * (n - 2) : 0)}px`
    else return `${28 + ((n > 2) ? 2 * (n - 2) : 0)}vw`
  }


  /** Llena las matrices de dependencia del BUSelectorData */
  private fillDependencyMatrices(): void {
    // Llenar las matrices de dependencia de los carriers.
    this.select.carrDepn = this.select.carriers.map(x => {
      const p = this.pseudoData.find(i => i.carrier === x)?.provider;
      return p ? [p] : [];
    });

    // Llenar las matrices de dependencia de los services.
    this.select.servDepn = this.select.services.map(x => {
      const c = new Set<string>(), p = new Set<string>();

      this.pseudoData.forEach(i => {
        if (i.service === x) {
          c.add(i.carrier);
          p.add(i.provider);
      }});

      return [Array.from(p).sort(), Array.from(c).sort()];
    });
  }

  /** Revisa si los campos de *provider* y *carrier* no tienen información.
    * @param {{ carrier: string | null, provider: string | null }} x - El objeto por revisar.
    * @returns {boolean} `true` si tanto *provider* como *carrier* son "any" o `null/undefined`. */
  private noDataAvailable(x: { carrier: string | null, provider: string | null }): boolean {
    // Si no tiene información del carrier:
    if (!x.carrier || x.carrier?.trim().length === 0) return true;
    // Si tiene información del carrier y del provider:
    if (x.provider && x.provider != 'any') return false;
    // Failsafe
    return true;
  }
  
  openInventarioEditarRecibido(id: number, recibido: number, tipo: string, nombre: string, id_mat: number){
    this.matDialog.open(InventarioEditRecibidoComponent, {
      panelClass: ['dialogs-sm'],
      data: {
        campaign : this.campana,
        recibido: recibido,
        id: id,
        tipo: tipo,
        nombre: nombre,
        bitSemaforo: this.campana?.bitSemaforo,
        id_mat: id_mat,
        id_camp : this.campana.id,
      }
    }).afterClosed().subscribe(
      resp => {
        if(resp?.reload) this.loadCampaignData(this.campana.id);
      }
    );
  }

  openInventarioHistorial(id: number, tipo: string){
    this.matDialog.open(InventarioHistorialComponent, {
      panelClass: ['dialogs-md'],
      data: {
        id: id,
        tipo: tipo
      }
    }).afterClosed().subscribe(
      resp => {
      }
    );
  }

  activateSemaforo(bitSemaforo: number){
    let actionBit = bitSemaforo == 1 ? 0 : 1;
    Swal.fire({
      icon: 'info',
      title: 'Espere...',
      allowEscapeKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    this.campaignS.changeStatusSemaforo(this.campana.id, actionBit).subscribe(
      (result: any) => {
        if (result.message == "Success") {
          Swal.fire({
            icon: 'success',
            title: 'Actualizado'
          }).then(() => {
            this.loadCampaignData(this.campana.id);
          });
        }
      },
      (err: any) => {
        Swal.fire({
          icon: 'error',
          title: 'Error al actualizar',
          text: 'Ocurrió un error al actualizar el registro, por favor vuelva a intentarlo.'
        });
      }
    );
  }

  editCell(rowIndex: number, colName: string, currentValue: any): void {
    //Almacena la referencia a la celda que se está editando
    this.editingCell = { row: rowIndex, col: colName };
    setTimeout(() => {
      const input = document.querySelector('.editable-input') as HTMLInputElement;
      if (input) {
        input.focus();
      }
    }, 0);
  }

  isEditing(rowIndex: number, colName: string): boolean {
    return this.editingCell.row === rowIndex && this.editingCell.col === colName;
  }

  saveCell(rowIndex: number, colName: string, row:any): void {
    this.editingCell = { row: null, col: null };

    let objData = {
      id_campana: this.campana.id,
      sku: row.sku,
      peso: row.peso
    }

    this.distService.editPeso(objData).subscribe(
      (result: any) => {
        Swal.fire({
          icon: 'success',
          title: 'Peso Editado',
          text: ''
        });
      },
      (err: any) => {
        console.log(err);
        Swal.fire({
          icon: 'error',
          title: 'Error al editar',
          text: 'Ocurrió un error al editar el peso'
        });
      }
    );
    
    
  }


  showPickupEvidence(id: string) {
    this.matDialog.open(ViewPickupEvidenceComponent, {
      data: { id: id },
      panelClass: 'dialogs-main'
    });
  }

  openUploadMaterialesDist(){
    this.matDialog.open(DistributionUploadMaterialesComponent, {
      panelClass: ['dialogs-lg'],
      data: {
        campaign : this.campana
      }
    }).afterClosed().subscribe(
      resp => {
        if(resp?.reload) this.loadCampaignData(this.campana.id);
      }
    );
  }

  activateSepararKit(bitSeparar: number){
    let actionBit = bitSeparar == 1 ? 0 : 1;
    Swal.fire({
      icon: 'info',
      title: 'Espere...',
      allowEscapeKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    this.campaignS.changeStatusSepararKit(this.campana.id, actionBit).subscribe(
      (result: any) => {
        if (result.message == "Success") {
          Swal.fire({
            icon: 'success',
            title: 'Actualizado'
          }).then(() => {
            this.loadCampaignData(this.campana.id);
          });
        }
      },
      (err: any) => {
        Swal.fire({
          icon: 'error',
          title: 'Error al actualizar',
          text: 'Ocurrió un error al actualizar el registro, por favor vuelva a intentarlo.'
        });
      }
      )
    }

    onChangeActualizacionAutomatica(id: any, tracking_active: any){
    let actionBit = tracking_active == 1 ? 0 : 1;
    Swal.fire({
      icon: 'info',
      title: 'Espere...',
      allowEscapeKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    this.campaignS.changeActAutomatica(id, actionBit).subscribe(
      (result: any) => {
        if (result.message == "Success") {
          Swal.fire({
            icon: 'success',
            title: 'Actualizado'
          }).then(() => {
            this.loadCampaignData(this.campana.id);
          });
        }
      },
      (err: any) => {
        Swal.fire({
          icon: 'error',
          title: 'Error al actualizar',
          text: 'Ocurrió un error al actualizar el registro, por favor vuelva a intentarlo.'
        });
      }
      )
    }

  openDialogEstacionesComparteInventario(row:any) {
    this.matDialog.open(RackComparteInvComponent, {
      panelClass: ['dialogs-sm'],
      data: {
        rack : row,
        estaciones: this.dsRacks.data
      }
    }).afterClosed().subscribe(
      resp => {
        if(resp?.reload) this.loadCampaignData(this.campana.id);
      }
    );
  }

  generateFileGuias(row: any){
    
    Swal.fire({
      icon: 'info',
      title: 'Generando archivo...',
      allowEscapeKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    this.distService.generateFileGuide(row).subscribe(
      (result: any) => {
        if (result.message == "Success") {
          Swal.fire({
            icon: 'success',
             title: 'Archivo creado',
              text: 'Archivo generado de manera correcta!'
          }).then(() => {
            this.loadCampaignData(this.campana.id);
            this.loadFilesGuias(this.campana.id);
          });
        }
      }),
      (err: any) => {
        Swal.fire({
          icon: 'error',
          title: 'Error al generar',
          text: 'Ocurrió un error, por favor vuelva a intentarlo.'
        });
      }
  }

  toggleRow(row: any) {
    const index = this.selectedRows.indexOf(row);

    if (index === -1) {
        this.selectedRows.push(row);
    } else {
        this.selectedRows.splice(index, 1);
    }
  }

  isSelectedGuias(row: any): boolean {
    return this.selectedRows.includes(row);
  }

  toggleAllRowsGuias(event: any) {
    if (event.checked) {
        this.selectedRows = this.dsArchivos.data;
    } else {
        this.selectedRows = [];
    }
  }

  isAllSelectedGuias(): boolean {
    if (!this.dsArchivos || !this.dsArchivos.data) {
        return false;
    }
    return this.selectedRows.length === this.dsArchivos.data.filter((r: any) => r.file != null).length;
  }

  downloadZipGuias() {

    const files = this.selectedRows.map((row: any) => ({
      url: row.file,
      name: `${row.nombre}.pdf`
    }));

    this.distService.downloadZipGuias(files).subscribe((blob: Blob) => {

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');

      link.href = url;
      link.download = `guias_${this.campana?.name || ''}.zip`;
      link.click();

      window.URL.revokeObjectURL(url);

    });
  }


  generarArchivos(){

    Swal.fire({
      icon: 'info',
      title: 'Generando archivos...',
      allowEscapeKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    this.distService.generateFileGuides(this.selectedRows).subscribe(
      (result: any) => {
        if (result.message == "Success") {
          Swal.fire({
            icon: 'success',
             title: 'Archivos creados',
              text: 'Archivos generados de manera correcta!'
          }).then(() => {
            this.loadCampaignData(this.campana.id);
            this.loadFilesGuias(this.campana.id);
            this.selectedRows = [];
          });
        }
      }),
      (err: any) => {
        Swal.fire({
          icon: 'error',
          title: 'Error al generar',
          text: 'Ocurrió un error, por favor vuelva a intentarlo.'
        });
      }

  }
   
}